"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const toolkit_1 = require("@reduxjs/toolkit");
const primaryButton_1 = __importDefault(require("../../components/primaryButton/primaryButton"));
const theme_1 = __importDefault(require("../../styles/theme"));
const logo_1 = __importDefault(require("../../components/logo/logo"));
const screenConstants_1 = require("../../constants/screenConstants");
const questionManager_1 = __importDefault(require("../../components/questionManager/questionManager"));
const surveySlice_1 = require("./surveySlice");
const useAppNavigation_1 = __importDefault(require("../../hooks/useAppNavigation"));
const store_1 = require("../../store");
const homeSlice_1 = require("../home/homeSlice");
const icon_1 = require("../../components/icon/icon");
const styles_1 = __importDefault(require("../../styles/styles"));
const analytics_1 = require("../../utils/analytics/analytics");
const Survey = () => {
    const dispatch = (0, store_1.useAppDispatch)();
    const navigation = (0, useAppNavigation_1.default)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const { surveyQuestion, npsSurvey } = (0, store_1.useAppSelector)((state) => {
        return {
            surveyQuestion: state.survey.survey_question,
            npsSurvey: state.home.nps_survey,
        };
    });
    const [answer, setAnswer] = (0, react_1.useState)(9);
    const surveyCompleted = () => {
        dispatch((0, homeSlice_1.addMessages)([
            {
                title: 'Thank you for your time.',
                message: '',
                iconType: icon_1.GREEN_CHECK_CIRCLE,
                iconColor: theme_1.default.colors.COLOR_PRIMARY,
                iconSize: 55,
                buttonText: 'MAIN MENU',
                hasLogo: true,
                actionButton: () => navigation.navigate(screenConstants_1.HOME_SCREEN),
            },
        ]));
        dispatch((0, homeSlice_1.showMessage)());
    };
    const saveHandler = async () => {
        if (npsSurvey) {
            const result = await dispatch((0, surveySlice_1.saveFormsQuestions)({
                answer: typeof answer === 'boolean' ? -1 : answer,
                question_id: npsSurvey.question_id,
                loan_id: npsSurvey.loan_id,
            }));
            logEventWithExtraProperties('api_call', {
                name: 'submit_survey',
                status: 'submitted',
                location: 'screen_Survey',
                question_id: npsSurvey.question_id,
                loan_id: npsSurvey.loan_id,
            });
            if ((0, toolkit_1.isFulfilled)(result)) {
                logEventWithExtraProperties('api_call', {
                    name: 'submit_survey',
                    status: 'success',
                    location: 'screen_Survey',
                    question_id: npsSurvey.question_id,
                    loan_id: npsSurvey.loan_id,
                });
            }
            else {
                logEventWithExtraProperties('api_call', {
                    name: 'submit_survey',
                    status: 'fail',
                    location: 'screen_Survey',
                    question_id: npsSurvey.question_id,
                    loan_id: npsSurvey.loan_id,
                });
            }
            if ((0, toolkit_1.isFulfilled)(result) && result.payload && Object.keys(result.payload).length === 0) {
                surveyCompleted();
            }
        }
        else {
            surveyCompleted();
        }
    };
    return (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.centerChildHorizontalVertical },
                react_1.default.createElement(logo_1.default, { fixedSize: true })),
            react_1.default.createElement(react_native_1.View, null,
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne] },
                    react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne] },
                        react_1.default.createElement(questionManager_1.default, { key: surveyQuestion.id, survey_question: surveyQuestion, answer: answer, setAnswer: setAnswer })))),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.justifyFlexEnd },
                react_1.default.createElement(primaryButton_1.default, { disabled: false, title: "NEXT", onPress: saveHandler, eventName: "next_survey_question" })))));
};
exports.default = Survey;
